import React, { useEffect, useState } from "react";
import BottomBarPage from "../../includes/dashboard/BottomBarPage";
import LeftBarPage from "../../includes/dashboard/LeftBarPage";
import TopBarPage from "../../includes/dashboard/TopBarPage";
import { useCustomerKYCContext } from "../../../services/contexts/CustomerKYCContext";
import { Link, useHistory } from "react-router-dom";
import { computeNet, configs, downloadCSVUsingData, formatCurrency, formatNumber } from "../../../assets/Config";
import { useLogin } from "../../../services/contexts/CustomerLoginContext";
import '../../../assets/styles/dashboard.css';
import ToastPage from '../../includes/ToastPage'
import ClientOrderPage from "../clientData/ClientOrderPage";
import { useClientDataContext } from "../../../services/contexts/ClientDataContext";
import '../../../assets/styles/Analytics.css';
import balance from '../../../assets/images/balance.svg';
import commission from '../../../assets/images/commission.svg';
import payout from '../../../assets/images/payout.svg';
import { updateBrandingDetails } from "../../../services/apis/CustomerKYCApi";
import imageCompression from "browser-image-compression";

export default function BrandingPage() {

    const { setShowMobBS, setCurrModule, setcurrMod, token, setShowSuccess, logout } = useLogin()

    const history = useHistory()

    const [vision, setVision] = useState("")
    const [mission, setMission] = useState("")
    const [addInfo, setAddInfo] = useState("")
    const [logo, setLogo] = useState("")
    const [visionStatus, setVisionStatus] = useState("")
    const [missionStatus, setMissionStatus] = useState("")
    const [addInfoStatus, setAddInfoStatus] = useState("")
    const [logoStatus, setLogoStatus] = useState("")
    const [activeVision, setActiveVision] = useState("")
    const [activeMission, setActiveMission] = useState("")
    const [activeAddInfo, setActiveAddInfo] = useState("")
    const [activeLogo, setActiveLogo] = useState("")
    const [error, setError] = useState("")

    useEffect(() => {
        if (configs.isWealthManager.toLowerCase() === configs.distributorTypes.wealth_manager.toLowerCase()) {
            setShowMobBS(false)
            setCurrModule(configs.modules.branding)
            setcurrMod(configs.modules.branding)
            getBrandingData()
        } else {
            history.goBack()
        }

    }, [])

    async function uploadFile(file) {
        try {
            if (file.type === "image/jpg" || file.type === "image/jpeg" || file.type === "image/png") {
                try {
                    const options = {
                        maxSizeMB: 2,              // target ≤ 2 MB
                        maxWidthOrHeight: 1920,    // resize if necessary
                        useWebWorker: true,
                    };

                    const compressedFile = await imageCompression(file, options);
                    file = compressedFile;
                } catch (error) {
                    console.error(error);

                }
            }
            if (file.type === "image/jpg" || file.type === "image/jpeg" || file.type === "image/png" && file.size <= 2000000) {
                setLogo(file);
            } else {
                setLogo("");
                setError(file.size > 2000000 ? "File size greather than allowed file size 2 MB" : "File type not allowed")
            }
        } catch (error) {
            console.error(error);
        }
    }

    async function getBrandingData() {
        try {
            let response = await updateBrandingDetails(token, true)
            if (response && response.status === 200) {
                setActiveVision(response.data.vision)
                setActiveMission(response.data.mission)
                setActiveAddInfo(response.data.additional_info)
                setActiveLogo(response.data.logo)
                setVision(response.data.vision_update)
                setMission(response.data.mission_update)
                setAddInfo(response.data.additional_info_update)
                setLogo(response.data.logo_update)
                setVisionStatus(response.data.vision_status)
                setMissionStatus(response.data.mission_status)
                setAddInfoStatus(response.data.additional_info_status)
                setLogoStatus(response.data.logo_status)
                setError("")
            } else if (response && response.status === 401) {
                logout();
            } else {
            }
        } catch (error) {
            console.error(error);
        }
    }

    async function updateBrandingData(e) {
        try {
            if (vision && vision.trim() === activeVision && mission && mission.trim() === activeMission && addInfo && addInfo.trim() === activeAddInfo) {
                setError("No changes to update");
            } else {
                e.preventDefault()
                document.getElementById("brandingBtn").classList.add("d-none")
                document.getElementById("brandingBtnLoader").classList.remove("d-none")
                let response = await updateBrandingDetails(token, false, vision, mission, addInfo, logo)
                if (response && response.status === 200) {
                    setShowSuccess(true);
                    getBrandingData();
                    setError("")
                } else if (response && response.status === 401) {
                    logout();
                } else {
                    setError(response.data.error)
                }
            }
        } catch (error) {
            console.error(error);
        } finally {
            if (e) {
                document.getElementById("brandingBtn").classList.remove("d-none")
                document.getElementById("brandingBtnLoader").classList.add("d-none")
            }
        }
    }


    return (
        <div className="initial-div">
            <TopBarPage />
            <div className="initial-contain">
                <LeftBarPage />
                <div id='commissionContainer' className="dash-main" >
                    <div className="row dashTitle">
                        <div className="col-6">
                            Personal Branding
                        </div>
                    </div>
                    <form action="" className="mb-4 mx-3">
                        <div className="row m-0 p-0">
                            <div className="col-md-6 col-12">
                                <div className="form-group">
                                    <div className="row m-0 p-0 d-flex justify-content-between">
                                        <div className="col-6 m-0 p-0">
                                            <label htmlFor="logo">Logo</label>
                                        </div>
                                        <div className="col-6 m-0 p-0 text-right text-capitalize">
                                            {logoStatus ? <label>Status: <b>{logoStatus}</b></label> : null}
                                        </div>
                                    </div>
                                    
                                    <div id="logo_up" className="file-border rounded pt-2" onDragOver={(e) => {
                                        e.preventDefault();
                                    }} onDrop={(e) => {
                                        uploadFile(e.dataTransfer.files[0])
                                        e.preventDefault();
                                    }}>
                                        <i className="fas fa-file-upload f-18"></i>
                                        <p className="f-12">
                                            Drag your file or &nbsp;
                                            <input type="file" id="logo" hidden accept="image/jpg, image/jpeg, image/png" onChange={(e) => {
                                                uploadFile(e.target.files[0])
                                            }} />
                                            <label className="f-12" htmlFor="logo">Click here</label>
                                            &nbsp; to choose. <br /> Upload : <span className="text-theme">{logo && logo.name ? logo.name : ""}</span>
                                        </p>

                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6 col-12">
                                <div className="form-group">
                                    <div className="row m-0 p-0 d-flex justify-content-between">
                                        <div className="col-6 m-0 p-0">
                                            <label htmlFor="vision">Vision</label>
                                        </div>
                                        <div className="col-6 m-0 p-0 text-right text-capitalize">
                                            {visionStatus ? <label>Status: <b>{visionStatus}</b></label> : null}
                                        </div>
                                    </div>
                                    <textarea name="vision" id="vision" className="w-100 form-control address-textarea" rows="5" value={vision} onChange={(e) => {
                                        setVision(e.target.value)
                                    }} />
                                </div>
                            </div>
                            <div className="col-md-6 col-12">
                                <div className="form-group">
                                    <div className="row m-0 p-0 d-flex justify-content-between">
                                        <div className="col-6 m-0 p-0">
                                            <label htmlFor="mission">Mission</label>
                                        </div>
                                        <div className="col-6 m-0 p-0 text-right text-capitalize">
                                            {missionStatus ? <label>Status: <b>{missionStatus}</b></label> : null}
                                        </div>
                                    </div>
                                    <textarea name="mission" id="mission" className="w-100 form-control address-textarea" rows="5" value={mission} onChange={(e) => {
                                        setMission(e.target.value)
                                    }} />
                                </div>
                            </div>
                            <div className="col-md-6 col-12">
                                <div className="form-group">
                                    <div className="row m-0 p-0 d-flex justify-content-between">
                                        <div className="col-6 m-0 p-0">
                                            <label htmlFor="addInfo">Additional Info</label>
                                        </div>
                                        <div className="col-6 m-0 p-0 text-right text-capitalize">
                                            {addInfoStatus ? <label>Status: <b>{addInfoStatus}</b></label> : null}
                                        </div>
                                    </div>
                                    <textarea name="addinfo" id="addinfo" className="w-100 form-control address-textarea" rows="5" value={addInfo} onChange={(e) => {
                                        setAddInfo(e.target.value)
                                    }} />
                                </div>
                            </div>
                        </div>
                        <div className="form-check p-0">
                            <p className="text-danger" id="error">{error}</p>
                        </div>
                        <button id="brandingBtn" className="btn btn-primary rounded px-4" onClick={updateBrandingData}>Update</button>
                        <div id="brandingBtnLoader" className='animBtn d-none'><div className='gSignIn-Anim'></div></div>
                    </form>

                    {/* -----------------------------active status------------------------------- */}
                    {activeLogo || activeVision || activeMission || activeAddInfo ? <>
                        <div className="row dashTitle">
                            <div className="col-12 text-align-center">
                                Active Details
                            </div>
                        </div>
                        <div className="row m-0 p-0">
                            <div className="col-md-6 col-12">
                                <div className="form-group">
                                    <label htmlFor="logo">Logo</label>
                                </div>
                                <img src={`${process.env.REACT_APP_BASEURL}/all/distributorLogo/${activeLogo}`} alt="logo" style={{ height: "8rem", width: "8rem", objectFit: "contain" }} />
                            </div>
                            <div className="col-md-6 col-12">
                                <div className="form-group">
                                    <label htmlFor="activeVision">Vision</label>
                                    <textarea name="activeVision" id="activeVision" className="w-100 form-control address-textarea" disabled rows="5" defaultValue={activeVision} />
                                </div>
                            </div>
                            <div className="col-md-6 col-12">
                                <div className="form-group">
                                    <label htmlFor="activeMission">Mission</label>
                                    <textarea name="activeMission" id="activeMission" className="w-100 form-control address-textarea" disabled rows="5" defaultValue={activeMission} />
                                </div>
                            </div>
                            <div className="col-md-6 col-12">
                                <div className="form-group">
                                    <label htmlFor="activeAddInfo">Additional Info</label>
                                    <textarea name="activeAddInfo" id="activeAddInfo" className="w-100 form-control address-textarea" disabled rows="5" defaultValue={activeAddInfo} />
                                </div>
                            </div>
                        </div>
                    </> : null}
                </div>
            </div>
            <BottomBarPage />
            <ToastPage />
            {/* //     </div> */}
        </div >

    )
}